/* App.js */
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import { TabProvider } from "@/contexts/TabContext";
import Layout from "@/layout/Layout";
import { Loading } from "@/components";

import {
    // 헤더 없는 화면
    Login,
    Auth,
    SignUp,
    // 헤더 포함 화면
    Dashboard,
    // 2. 차량 현황
    VehicleManage,
    VehicleRegister,
    VehicleRegisterExcel,
    VehicleWaiting,
    VehicleGarage,
    GarageRegister,
    ParkingRegister,
    // 3. 보험 영업
    OrderManage,
    OrderAssignment,
    OrderRegister,
    OrderDetail,
    // 4. 임대차 계약서
    ContractStatus,
    ContractRegister,
    ContractPreview,
    ContractDetail,
    ContractEditBasicInfo,
    ContractEditDetail,
    // 5. 탁송
    DeliveryRequest,
    DeliveryHistory,
    // 7. 마일리지/포인트
    MileageHistory,
    // 8. 청구/수납
    BillingStatus,
    BillingRequest,
    // 10. 일반 관리
    Mypage,
    Notice,
    NoticeDetail,
    NoticeRegister,
    Notification,
    PolicyManagement,
    InsuranceManagement,
    PartnerManagement,
    OperatorManagement,
    WorkshopManagement,
    AddressManagement,
    PolicyRegister,
    InsuranceRegister,
    PartnerRegister,
    OperatorRegister,
    WorkshopRegister,
    AddressRegister,
    // 11. 사업자 관리
    BusinessManage,
    BusinessRegister,
    // 12. ERP 관리
    AdminMemberManage,
    AdminMemberRegister,
    AdminMemberOrder,
    AdminMemberOrderDetail,
    AdminVehicleManage,
    AdminVehicleRegister,
    AdminOrderManage,
    AdminOrderDetail,
    AdminContractStatus,
    AdminContractRegister,
    AdminDeliveryHistory,
    AdminMileageHistory,
    AdminBillingStatus,
    AdminNotice,
    AdminNoticeRegister,
    AdminEvent,
    AdminEventRegister,
    AdminRelease,
    AdminReleaseRegister,
    InsCorpManagement,
    // 내브에 포함되지 않는 화면
    MyPage,
    Tutorial,
    BusinessRegisterFirst,
    // 전자계약서
    ElectronicContract,
} from "@/pages";

import "react-datepicker/dist/react-datepicker.css";
import "@/assets/css/reset.css";
import "@/assets/css/fonts.css";
import "@/assets/css/root.css";
import "@/assets/css/layout.css";
import "@/assets/css/common.css";
import "@/assets/css/style.css";
import {BillingDetail} from "./pages/Billing/BillingDetail";
import {OnlineContractStatus} from "./pages/Contract/OnlineContractStatus";
import {SendFailContract} from "./pages/Contract/SendFailContract";
import {AdminSelfClaimManage} from "./pages/ERP/AdminSelfClaimManage";
import {AdminSelfClaimDetail} from "./pages/ERP/AdminSelfClaimDetail";

function App() {
    const isGlobalLoading = useSelector((state) => state.loading.isLoading);

    return (
        <div className="app">
            {isGlobalLoading && <Loading />}

            <Router>
                <TabProvider>
                    <Routes>
                        {/* 헤더 없는 화면 */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/auth/find" element={<Auth />} />
                        <Route path="/auth/signup" element={<SignUp />} />
                        <Route path="/tutorial" element={<Tutorial />} />

                        {/* 계약서 보기 */}
                        <Route path="/contract/preview/:contractGroupId/:contractId" element={<ContractPreview />} />

                        {/* 전자계약서 */}
                        <Route path="/mobile/contract/:contractId" element={<ElectronicContract />} />

                        {/* 헤더 포함 화면 */}
                        <Route element={<Layout />}>
                            {/* 대시보드 */}
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/dashboard" element={<Dashboard />} />

                            {/* 2. 차량 현황 */}
                            <Route path="/vehicle/manage" element={<VehicleManage />} />
                            <Route path="/vehicle/manage/register" element={<VehicleRegister />} />
                            <Route path="/vehicle/manage/edit/:vehicleId" element={<VehicleRegister />} />
                            <Route path="/vehicle/manage/register/excel" element={<VehicleRegisterExcel />} />
                            <Route path="/vehicle/waiting" element={<VehicleWaiting />} />
                            <Route path="/vehicle/garage" element={<VehicleGarage />} />
                            <Route path="/vehicle/garage/register" element={<GarageRegister />} />
                            <Route path="/vehicle/garage/edit/:locationId" element={<GarageRegister />} />
                            <Route path="/vehicle/parking/register" element={<ParkingRegister />} />
                            <Route path="/vehicle/parking/edit/:parkingId" element={<ParkingRegister />} />

                            {/* 3. 보험 영업 */}
                            <Route path="/order/manage" element={<OrderManage />} />
                            <Route path="/order/assignment" element={<OrderAssignment />} />
                            <Route path="/order/register" element={<OrderRegister />} />
                            <Route path="/order/detail/:orderId" element={<OrderDetail />} />

                            {/* 4. 임대차 계약서 */}
                            <Route path="/contract/status" element={<ContractStatus />} />
                            <Route path="/contract/online" element={<OnlineContractStatus />} />
                            <Route path="/contract/send/fail" element={<SendFailContract />} />
                            <Route path="/contract/register" element={<ContractRegister />} />
                            <Route path="/contract/detail/:contractGroupId" element={<ContractDetail />} />
                            <Route path="/contract/edit/basic-info/:contractGroupId" element={<ContractEditBasicInfo />} />
                            <Route path="/contract/register/contract/:contractGroupId" element={<ContractEditDetail />} />
                            <Route path="/contract/edit/detail/:contractGroupId" element={<ContractEditDetail />} />

                            {/* 5. 탁송 */}
                            <Route path="/delivery/request" element={<DeliveryRequest />} />
                            <Route path="/delivery/history" element={<DeliveryHistory />} />

                            {/* 7. 마일리지/포인트 */}
                            <Route path="/mileage/history" element={<MileageHistory />} />

                            {/* 8. 청구/수납 */}
                            <Route path="/billing/status" element={<BillingStatus />} />
                            <Route path="/billing/request" element={<BillingRequest />} />
                            <Route path="/billing/detail/:chargeId" element={<BillingDetail />} />

                            {/* 10. 일반 관리 */}
                            <Route path="/admin/mypage" element={<Mypage />} />
                            <Route path="/admin/notice" element={<Notice />} />
                            <Route path="/admin/notice/:noticeId" element={<NoticeDetail />} />
                            <Route path="/admin/notice/register" element={<NoticeRegister />} />
                            <Route path="/admin/notification" element={<Notification />} />
                            <Route path="/admin/policy-management" element={<PolicyManagement />} />
                            <Route path="/admin/insurance-management" element={<InsuranceManagement />} />
                            <Route path="/admin/partner-management" element={<PartnerManagement />} />
                            <Route path="/admin/operator-management" element={<OperatorManagement />} />
                            <Route path="/admin/workshop-management" element={<WorkshopManagement />} />
                            <Route path="/admin/policy-management/register" element={<PolicyRegister />} />
                            <Route path="/admin/insurance-management/register" element={<InsuranceRegister />} />
                            <Route path="/admin/insurance-management/edit/:id" element={<InsuranceRegister />} />
                            <Route path="/admin/partner-management/register" element={<PartnerRegister />} />
                            <Route path="/admin/operator-management/register" element={<OperatorRegister />} />
                            <Route path="/admin/workshop-management/register" element={<WorkshopRegister />} />
                            <Route path="/admin/address-management/register" element={<AddressRegister />} />
                            <Route path="/admin/policy-management/edit/:termId" element={<PolicyRegister />} />
                            <Route path="/admin/partner-management/edit/:id" element={<PartnerRegister />} />
                            <Route path="/admin/operator-management/edit/:id" element={<OperatorRegister />} />
                            <Route path="/admin/workshop-management/edit/:id" element={<WorkshopRegister />} />

                            {/* 11. 사업자 관리 */}
                            <Route path="/business/manage" element={<BusinessManage />} />
                            <Route path="/business/manage/edit/:id" element={<BusinessRegister />} />
                            <Route path="/business/register" element={<BusinessRegister />} />

                            {/* ERP 관리 */}
                            <Route path="/erp/member/manage" element={<AdminMemberManage />} />
                            <Route path="/erp/member/manage/edit/:memberId" element={<AdminMemberRegister />} />
                            <Route path="/erp/member/order" element={<AdminMemberOrder />} />
                            <Route path="/erp/member/order/detail/:memberId" element={<AdminMemberOrderDetail />} />
                            <Route path="/erp/vehicle/manage" element={<AdminVehicleManage />} />
                            <Route path="/erp/vehicle/manage/edit/:vehicleId" element={<AdminVehicleRegister />} />
                            <Route path="/erp/order/manage" element={<AdminOrderManage />} />
                            <Route path="/erp/self-claim/manage" element={<AdminSelfClaimManage />} />

                            <Route path="/erp/order/detail/:orderId" element={<AdminOrderDetail />} />

                            <Route path="/erp/self-claim/detail/:orderId" element={<AdminSelfClaimDetail />} />

                            <Route path="/erp/contract/status" element={<AdminContractStatus />} />
                            <Route path="/erp/contract/edit/:contractGroupId" element={<AdminContractRegister />} />
                            <Route path="/erp/delivery/history" element={<AdminDeliveryHistory />} />
                            <Route path="/erp/mileage/history" element={<AdminMileageHistory />} />
                            <Route path="/erp/billing/status" element={<AdminBillingStatus />} />
                            <Route path="/erp/notice" element={<AdminNotice />} />
                            <Route path="/erp/notice/register" element={<AdminNoticeRegister />} />
                            <Route path="/erp/notice/edit/:id" element={<AdminNoticeRegister />} />
                            <Route path="/erp/event" element={<AdminEvent />} />
                            <Route path="/erp/event/register" element={<AdminEventRegister />} />
                            <Route path="/erp/event/edit/:id" element={<AdminEventRegister />} />
                            <Route path="/erp/address-management" element={<AddressManagement />} />
                            <Route path="/erp/address-management/edit/:id" element={<AddressRegister />} />
                            <Route path="/erp/release" element={<AdminRelease />} />
                            <Route path="/erp/release/register" element={<AdminReleaseRegister />} />
                            <Route path="/erp/release/edit/:id" element={<AdminReleaseRegister />} />

                            {/* 내브에 포함되지 않는 화면 */}
                            <Route path="/mypage" element={<MyPage />} />
                        </Route>
                    </Routes>
                </TabProvider>
            </Router>
        </div>
    );
}

export default App;
